import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareLines: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSquareLines"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM14 14.75H8V13.25H14V14.75ZM8 10.75H16V9.25H8V10.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareLines;
